import { useMutation } from "@tanstack/react-query"
import { useParams } from "@tanstack/react-router"
import { post } from "../post"
import { UsePostMutationQueryOptions } from "../types"
import type * as Api from "../../@client/api"
import { useHandleAsyncSafely } from "./use-handle-async-safely"
import { DefaultError } from "../../-components/error-context"

interface Props<ActionName extends keyof Api.POST> {
  url: ActionName
  entityId?: number | string
  requestInit?: RequestInit
  options?: UsePostMutationQueryOptions<ActionName>
}

export function useCommand<ActionName extends keyof Api.POST>({
  url,
  entityId,
  options,
  requestInit,
}: Props<ActionName>) {
  const params = useParams({ strict: false })
  const _id = entityId || params["id"]
  if (!_id) throw new DefaultError({ title: "No EntityId for command" })

  const handleAsyncSafely = useHandleAsyncSafely<Api.Output[ActionName]>()

  return useMutation({
    ...options,
    mutationKey: [url, requestInit],
    mutationFn: (arg: Api.Input[ActionName]) =>
      handleAsyncSafely(() =>
        post(url, arg, {
          ...requestInit,
          headers: {
            ...requestInit?.headers,
            "X-App-StreamId": `${_id}`,
          },
        })
      ),
  })
}
